import { Col, Row } from 'react-bootstrap';
import { useState } from 'react';

//components
import Button from '../../CustomButton/CustomButton.jsx';
import Radio from '../../CustomRadio/CustomRadio.jsx';
import InputTime from '../../GenericForm/Widgets/InputTime';

//elements
import Select from '../../../elements/Select.js';
import { Textarea, NumberInput } from '../../../elements/Input.js';

//utils
import { minutesToTimeInput } from '../../../utils/timeCalc.js';
import { timeFormat, shortDateFormat, totalTimeFormat } from '../../../utils/dateFormat.js';

function TimesheetAdjustmentByAbsence({ userPromptModal, t, dateTimeRules }) {
    const timesheetAdjustmentByAbsenceData = userPromptModal.sourceInfo.timesheetAdjustmentByAbsence;
    return (
        <div>
            <div className='fw-bold'>{t('A short absence has been detected in the system')}</div>
            <span className='fw-bold mb-2'>
                {t('T&C has adjusted this timesheet accordingly') + ': '}
                <div>
                    {timesheetAdjustmentByAbsenceData.isTimesheetStartTimeAdjusted ? (
                        <span className='fw-bold'>{t('Start Time')} {t('changed from')} <span className='fw-bold text-danger'>{timeFormat(timesheetAdjustmentByAbsenceData.timesheetStartTimeBeforeAdjustment, dateTimeRules)}</span> {('to')} <span className='fw-bold text-success'>{timeFormat(timesheetAdjustmentByAbsenceData.adjustedTimesheetStartTime, dateTimeRules)}</span></span>
                    ) : (
                        <span className='fw-bold'>{t('End Time')} {t('changed from')} <span className='fw-bold text-danger'>{timeFormat(timesheetAdjustmentByAbsenceData.timesheetEndTimeBeforeAdjustment, dateTimeRules)}</span> {('to')} <span className='fw-bold text-success'>{timeFormat(timesheetAdjustmentByAbsenceData.adjustedTimesheetEndTime, dateTimeRules)}</span></span>
                    )}
                </div>
            </span>

            <div className="row timelog-grid-time-card">
                <table className='table mt-0'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{t('Start Time')}</th>
                            <th>{t('End Time')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%', textAlign: 'left', paddingLeft: '35px' }}>{t('Timesheet')}</td>
                            <td><span className={timesheetAdjustmentByAbsenceData.isTimesheetStartTimeAdjusted ? 'text-success' : ''}>{timeFormat(timesheetAdjustmentByAbsenceData.adjustedTimesheetStartTime, dateTimeRules)}</span></td>
                            <td><span className={timesheetAdjustmentByAbsenceData.isTimesheetEndTimeAdjusted ? 'text-success' : ''}>{timeFormat(timesheetAdjustmentByAbsenceData.adjustedTimesheetEndTime, dateTimeRules)}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row timelog-grid-time-card">
                <table className='table mt-0'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{t('Start Time')}</th>
                            <th>{t('End Time')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%', textAlign: 'left', paddingLeft: '35px' }}>{`${t('Absence')} (${t(timesheetAdjustmentByAbsenceData.absenceType)})`}</td>
                            <td>{timeFormat(timesheetAdjustmentByAbsenceData.intersectingAbsenceStartTime, dateTimeRules)}</td>
                            <td>{timeFormat(timesheetAdjustmentByAbsenceData.intersectingAbsenceEndTime, dateTimeRules)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {timesheetAdjustmentByAbsenceData.canCreateSecondTimesheet ? <div>
                <div className='fw-bold'>{t('If you want to create remaining timesheet as following then please click following button and save timesheet.')}</div>
                <div className="row timelog-grid-time-card">
                    <table className='table mt-0'>
                        <thead>
                            <tr>
                                <th></th>
                                <th>{t('Start Time')}</th>
                                <th>{t('End Time')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: '40%', textAlign: 'left', paddingLeft: '35px' }}>{t('Timesheet')}</td>
                                <td><span>{timeFormat(timesheetAdjustmentByAbsenceData.intersectingAbsenceEndTime, dateTimeRules)}</span></td>
                                <td><span>{timeFormat(timesheetAdjustmentByAbsenceData.timesheetEndTimeBeforeAdjustment, dateTimeRules)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {["timesheetAdjustmentByAbsence"].includes(userPromptModal.source) && timesheetAdjustmentByAbsenceData.canCreateSecondTimesheet ? <div>
                    <Button fill wd onClick={() => userPromptModal.actionMethods.adjustTimesheetForAbsence({
                        from: minutesToTimeInput(timesheetAdjustmentByAbsenceData.secondTimesheetStartTime),
                        to: minutesToTimeInput(timesheetAdjustmentByAbsenceData.secondTimesheetEndTime),
                        for_date: timesheetAdjustmentByAbsenceData.secondTimesheetForDate
                    })}>
                        <i className="fa fa-plus-circle fa-xl margin-right-10" />
                        {t('Add Remaining Timesheet')}
                    </Button>
                </div> : null}
            </div> : null}
        </div>
    )
}

function TimesheetAdjustmentByTimesheet({ userPromptModal, t, dateTimeRules }) {
    const timesheetAdjustmentByTimesheetData = userPromptModal.sourceInfo.timesheetAdjustmentByTimesheet;
    return (
        <div>
            <div className='fw-bold'>{t('Another timesheet has been detected in the system')}</div>
            <span className='fw-bold mb-2'>
                {t('T&C has adjusted this timesheet accordingly') + ': '}
                <div>
                    {timesheetAdjustmentByTimesheetData.isTimesheetStartTimeAdjusted ? (
                        <span className='fw-bold'>{t('Start Time')} {t('changed from')} <span className='fw-bold text-danger'>{timeFormat(timesheetAdjustmentByTimesheetData.timesheetStartTimeBeforeAdjustment, dateTimeRules)}</span> {('to')} <span className='fw-bold text-success'>{timeFormat(timesheetAdjustmentByTimesheetData.adjustedTimesheetStartTime, dateTimeRules)}</span></span>
                    ) : (
                        <span className='fw-bold'>{t('End Time')} {t('changed from')} <span className='fw-bold text-danger'>{timeFormat(timesheetAdjustmentByTimesheetData.timesheetEndTimeBeforeAdjustment, dateTimeRules)}</span> {('to')} <span className='fw-bold text-success'>{timeFormat(timesheetAdjustmentByTimesheetData.adjustedTimesheetEndTime, dateTimeRules)}</span></span>
                    )}
                </div>
            </span>

            <div className="row timelog-grid-time-card">
                <table className='table mt-0'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{t('Start Time')}</th>
                            <th>{t('End Time')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%', textAlign: 'left', paddingLeft: '35px' }}>{t('Timesheet')}</td>
                            <td><span className={timesheetAdjustmentByTimesheetData.isTimesheetStartTimeAdjusted ? 'text-success' : ''}>{timeFormat(timesheetAdjustmentByTimesheetData.adjustedTimesheetStartTime, dateTimeRules)}</span></td>
                            <td><span className={timesheetAdjustmentByTimesheetData.isTimesheetEndTimeAdjusted ? 'text-success' : ''}>{timeFormat(timesheetAdjustmentByTimesheetData.adjustedTimesheetEndTime, dateTimeRules)}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row timelog-grid-time-card">
                <table className='table mt-0'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{t('Start Time')}</th>
                            <th>{t('End Time')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%', textAlign: 'left', paddingLeft: '35px' }}>{`${t('Timesheet')} (Intersecting)`}</td>
                            <td>{timeFormat(timesheetAdjustmentByTimesheetData.intersectingTimesheetStartTime, dateTimeRules)}</td>
                            <td>{timeFormat(timesheetAdjustmentByTimesheetData.intersectingTimesheetEndTime, dateTimeRules)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    )
}

function TimebankOvertime({ userPromptModal, t, dateTimeRules }) {
    const timebankOvertimeData = userPromptModal.sourceInfo.timebankOvertime;
    return (
        <div>
            <span className='primary-page__title'>{t(timebankOvertimeData.message)}</span>
            <div className="mt-3">
                {timebankOvertimeData.calculatedTimebankBasedOnOvertime
                    && timebankOvertimeData.calculatedTimebankBasedOnOvertime.length ?
                    <>
                        <div className="row timelog-grid-time-card">
                            <table className='table mt-0'>
                                <thead>
                                    <tr>
                                        <th className='text-start'>{t('Overtime')}</th>
                                        <th className='text-start'>{t('Calculated Hours')}</th>
                                        <th className='text-start'>{t('To timebank')}</th>
                                        <th className='text-start'>{t('To payout')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {timebankOvertimeData.calculatedTimebankBasedOnOvertime.map((overtime) => (
                                        <tr>
                                            <td className='text-start'>{overtime?.overtimeName}</td>
                                            <td className='text-start'>{overtime?.calculatedHours}</td>
                                            <td className='text-start'>{overtime?.timebank}</td>
                                            <td className='text-start'>{overtime?.overtime}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                    :
                    <div className='text-start'>{t('No Overtime Record Found for the day')}!</div>
                }
            </div>
            <div className="d-flex justify-content-end mb-1">
                <Button fill wd
                    style={{ backgroundColor: 'green', border: 0 }}
                    onClick={userPromptModal.actionMethods.handleSaveToTimebank}
                >
                    {t('Save to Timebank')}
                </Button>
                <Button wd onClick={userPromptModal.actionMethods.handlePayALLHours} className="ms-3">
                    {t('No, Pay All Hours')}
                </Button>
            </div>
        </div>
    )
}

function MandatoryOvertimeFlexitime({ userPromptModal, t, dateTimeRules }) {
    const mandatoryOvertimeFlexitimeData = userPromptModal.sourceInfo.mandatoryOvertimeFlexitime;
    const { handleMandatoryTimelogModalClose, handleSubmitMandatoryTimelog } = userPromptModal.actionMethods;

    const overtimeOptions = mandatoryOvertimeFlexitimeData.overtime_types.map(e => ({ label: e.name, value: e.code }));
    const [mandatoryType, setMandatoryType] = useState(0);
    const [overtime, setOvertime] = useState(0);

    const data = {
        type: mandatoryType === 1 ? 'overtime' : mandatoryType === 2 ? 'flexitime' : null,
        overtimeCode: overtime
    }

    return (
        <>
            <Row className='m-4'>
                <div className='font-size-15 fw-bold font-color-primary'>
                    {mandatoryOvertimeFlexitimeData?.message}
                </div>
            </Row>
            <Row className='m-4'>
                {mandatoryOvertimeFlexitimeData?.mandatoryTypes?.includes('overtime') && (<Col>
                    <div className='font-size-12 fw-bold'>
                        <Radio
                            label={t('Register as Overtime')}
                            checked={mandatoryType === 1}
                            onChange={() => setMandatoryType(1)} />
                    </div>
                    {mandatoryType === 1 && <div className='font-size-12 fw-bold'>
                        <Select
                            options={overtimeOptions}
                            value={overtimeOptions.find(e => e.value === overtime)}
                            onChange={selected => setOvertime(selected.value)}
                            isClearable={false}
                        />
                    </div>}
                </Col>)}

                {mandatoryOvertimeFlexitimeData?.mandatoryTypes?.includes('flexitime') && (<Col>
                    <div className='font-size-12 fw-bold'>
                        <Radio
                            label={t("Register as Flextime")}
                            checked={mandatoryType === 2}
                            onChange={() => setMandatoryType(2)} />
                    </div>
                </Col>)}
            </Row>
            {!!mandatoryType && <Row className='m-4'>
                <Col xs={12}>
                    <div className='font-size-12 fw-bold'>
                        {t("Note")}:&nbsp;
                        {mandatoryType === 1 ?
                            t("Please select a overtime type and submit the timesheet to register as mandatory overtime") :
                            t("Please submit the timesheet to register as mandatory flextime")}.
                    </div>
                </Col>
            </Row>}
            <Row className="m-4">
                <Col xs={12}>
                    <Button
                        fill
                        success
                        style={{ width: '100%' }}
                        onClick={() => handleSubmitMandatoryTimelog(data)}
                    >
                        {t("Submit")}
                    </Button>
                </Col>
                <Col xs={12} className="mt-2">
                    <Button
                        style={{ width: '100%' }}
                        onClick={() => handleMandatoryTimelogModalClose(false)}
                    >
                        {t("Proceed to normal")}
                    </Button>
                </Col>
            </Row>
        </>
    )
}

function AdminPmComment({ userPromptModal, t }) {
    const { status, status_note, status_changed_by, status_changed_on } = userPromptModal.sourceInfo
    return <>
        <div><span className='fw-bold'><span className='text-capitalize fw-bold'>{t(status)}</span> {t('By')}:</span> {status_changed_by}</div>
        <div><span className='fw-bold'>{t('Date')}:</span> {status_changed_on}</div>
        <div>
            <lable><span className='fw-bold'>{t('Comment')}:</span></lable>
            <Textarea
                value={status_note || '-'}
                timelog_modal={"_timelog"}
                disabled={true}
            />
        </div>
    </>
}

function ConvertedOvertimeConflict({ userPromptModal, t }) {
    const { handleCloseUserPromptModal, handleResetTimebankAndProceed } = userPromptModal.actionMethods;
    const { message, subMessage } = userPromptModal.sourceInfo.convertedOvertimeConflict;
    return (
        <div>
            <p>{t(message)}</p>
            <p>{t(subMessage)}</p>
            <div className="d-flex justify-content-end mb-1">
                <Button fill success onClick={handleResetTimebankAndProceed}>
                    {t('Proceed')}
                </Button>
                <Button wd onClick={handleCloseUserPromptModal} className="ms-3">
                    {t('No')}
                </Button>
            </div>
        </div>
    )
}

function ResetAutoApprovedLog({ userPromptModal, t, dateTimeRules }) {
    const { handleConfirmResetAutoApprovedLog, handleCloseUserPromptModal } = userPromptModal.actionMethods;
    const { message, approvedLogs } = userPromptModal.sourceInfo.resetAutoApprovedLog;
    return (
        <div>
            <p>{t(message)}</p>
            {approvedLogs && approvedLogs.length > 0 && (
                <div className="row timelog-grid-time-card">
                    <table className='table mt-0'>
                        <thead>
                            <tr>
                                <th></th>
                                <th>{t('Start Time')}</th>
                                <th>{t('End Time')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {approvedLogs.map((log, index) => (
                                <tr key={index}>
                                    <td className="w-40 text-start ps-4">{t('Approved Timelog')} {approvedLogs.length > 1 ? index + 1 : ''}</td>
                                    <td>{log.fromFormatted}</td>
                                    <td>{log.toFormatted}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <div className="d-flex justify-content-end mb-1">
                <Button fill success onClick={handleConfirmResetAutoApprovedLog}>
                    {t('Yes, proceed')}
                </Button>
                <Button wd onClick={handleCloseUserPromptModal} className="ms-3">
                    {t('Cancel')}
                </Button>
            </div>
        </div>
    );
}

function ApprovedWeeklyOvertime({ userPromptModal, t, dateTimeRules }) {
    const { handleCloseUserPromptModal, handleResetApprovedWeeklyOvertime } = userPromptModal.actionMethods;
    const { message, approvedTimesheets } = userPromptModal.sourceInfo.approvedWeeklyOvertime;
    const canReset = userPromptModal.actions && userPromptModal.actions.some(ele => ele.action === 'RESET_APPROVED_WEEKLY_OVERTIME_TIMESHEETS');
    return (
        <div>
            <p>{t(message)}</p>
            {approvedTimesheets && approvedTimesheets.length > 0 && (
                <div className="row timelog-grid-time-card">
                    <table className='table mt-0'>
                        <thead>
                            <tr>
                                <th>{t('Date')}</th>
                                <th>{t('Time')}</th>
                                <th>{t('Weekly Overtime')}</th>
                                <th>{t('Status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {approvedTimesheets.map((timesheet, index) => (
                                <tr key={index}>
                                    <td>{shortDateFormat(timesheet.for_date, dateTimeRules)}</td>
                                    <td>{timeFormat(timesheet.start_time, dateTimeRules)} - {timeFormat(timesheet.end_time, dateTimeRules)}</td>
                                    <td>{totalTimeFormat(timesheet.weeklyOvertimeInMins, dateTimeRules)}</td>
                                    <td className="text-capitalize">{t(timesheet.status)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table >
                </div >
            )}
            <div className="d-flex justify-content-end mb-1">
                {canReset && (
                    <Button variant="warning" fill onClick={handleResetApprovedWeeklyOvertime}>
                        {t('Reset')}
                    </Button>
                )}
                <Button wd onClick={handleCloseUserPromptModal} className="ms-3">
                    {t('Close')}
                </Button>
            </div>
        </div>
    );
}

function OvertimeComment({ userPromptModal, t, dateTimeRules }) {
    const { handleSaveOvertimeComment, handleCloseUserPromptModal } = userPromptModal.actionMethods;
    const { message, overtimes } = userPromptModal.sourceInfo.overtimeComment;
    const [comment, setComment] = useState('');
    const overtimeRows = overtimes || [];
    return (
        <div>
            <div>{t(message)}</div>
            {overtimeRows.length ?
                <div className="row timelog-grid-time-card">
                    <table className='table mt-0'>
                        <thead>
                            <tr>
                                <th className='text-start'>{t('Name')}</th>
                                <th className='text-start'>{t('Hours')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {overtimeRows.map((overtime, index) => (
                                <tr key={index} className='text-capitalize'>
                                    <td className='text-start'>{overtime.name}</td>
                                    <td className='text-start'>{totalTimeFormat(overtime.valueInMins, dateTimeRules)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                :
                <div className='text-center'>{t('No Overtime Record Found for the day')}!</div>
            }
            <div>
                <label className="control-label mb-1">{t('Overtime Comment')}</label>
                <Textarea
                    className="overtime-comment-box"
                    value={comment}
                    style={{ width: '100%' }}
                    placeholder={t('Add comment for overtime')}
                    onChange={e => setComment(e.target.value)}
                />
            </div>
            <div className="d-flex justify-content-end mt-3">
                <Button fill success disabled={!comment.trim()} onClick={() => handleSaveOvertimeComment(comment.trim())}>
                    {t('Save')}
                </Button>
                <Button wd onClick={handleCloseUserPromptModal} className="ms-3">
                    {t('Close')}
                </Button>
            </div>
        </div>
    );
}

function AdditionalPaymentEntry({ userPromptModal, t }) {
    const { handleUpdateTimesheetWithExtraPayment, handleCloseUserPromptModal } = userPromptModal.actionMethods;
    const { message, workedMinutes, rules } = userPromptModal.sourceInfo.additionalPaymentEntry;
    const [entered, setEntered] = useState({});

    const hhmmToMinutes = (hhmm) => {
        if (!hhmm || !hhmm.split) return 0;
        const [h, m] = hhmm.split(':');
        return (parseInt(h) || 0) * 60 + (parseInt(m) || 0);
    };
    // Quantity is entered as a fraction 0-1.0; hours as hh:mm (capped at worked hours).
    const pointInvalid = (rules || []).some(rule => {
        if (rule.type !== 'manual_point_amount') return false;
        return (Number(entered[rule.code]) || 0) > 1;
    });
    const hourInvalid = (rules || []).some(rule => rule.type !== 'manual_point_amount' && hhmmToMinutes(entered[rule.code]) > workedMinutes);
    const invalid = pointInvalid || hourInvalid;

    return (
        <div>
            <p>{t(message)}</p>
            {(rules || []).map((rule) => (
                <div key={rule.code} className="d-flex align-items-center justify-content-between mb-2">
                    <span className="me-2 text-capitalize">{rule.name}</span>
                    {rule.type === 'manual_point_amount' ?
                        <NumberInput
                            style={{ maxWidth: '85px' }}
                            customClassses="text-center"
                            step="0.01"
                            min={0}
                            max={1}
                            placeholder="0.0"
                            value={entered[rule.code] || ''}
                            onChange={(e) => {
                                const decimals = e.target.value.split('.')[1];
                                if (decimals && decimals.length > 2) return;
                                setEntered(prev => ({ ...prev, [rule.code]: e.target.value }));
                            }}
                        />
                        :
                        <InputTime
                            className="big-input text-center"
                            value={entered[rule.code] || '00:00'}
                            onChange={(val) => setEntered(prev => ({ ...prev, [rule.code]: val }))}
                        />
                    }
                </div>
            ))}
            {invalid &&
                <div className="text-danger mt-2">
                    {pointInvalid ? t('Quantity must be between 0 and 1.0') : t('Additional payment hours cannot exceed the worked hours (start time to end time)')}
                </div>
            }
            <div className="d-flex justify-content-end mb-1 mt-3">
                <Button fill success disabled={invalid} onClick={() => handleUpdateTimesheetWithExtraPayment(entered)}>
                    {t('Update timesheet')}
                </Button>
                <Button wd onClick={handleCloseUserPromptModal} className="ms-3">
                    {t('Cancel')}
                </Button>
            </div>
        </div>
    );
}

export {
    TimesheetAdjustmentByAbsence,
    TimesheetAdjustmentByTimesheet,
    TimebankOvertime,
    MandatoryOvertimeFlexitime,
    AdminPmComment,
    ConvertedOvertimeConflict,
    ResetAutoApprovedLog,
    ApprovedWeeklyOvertime,
    OvertimeComment,
    AdditionalPaymentEntry
}